const yellow = {
  100: '#F1C40F'
};

export { yellow };
